import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import Button from '../../Button/Button';
import Paragraph from '../../Paragraph/Paragraph';
import {
  // selectMailInLearnMoreLink,
  selectSellMailInStorageUrl,
} from '../../../store/selectors/settingsSelectors';
import { pxToRem } from '../../../assets/styles/helper';
import { postCrmEventMailinStorageStarted } from '../../../store/actions/crmEvent/crmEventActions';
import { ReactComponent as Info } from '../../../assets/images/svg/info.svg';
import { ReactComponent as Close } from '../../../assets/images/svg/close.svg';
import { IconWrapper } from '../../Icons/IconWrapper';
import themeColors from '../../../assets/styles/themeColors';
import Anchor from '../../Anchor/Anchor';

const MailInCtaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: 'center';
  align-items: ${({ alignment }) => alignment || 'center'};
  gap: ${pxToRem(10)};
  margin-bottom: ${pxToRem(20)};
`;

const MailInTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TooltipContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  white-space: pre-wrap;
`;

const TooltipContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
`;

const MailInCtaButton = styled.div`
  flex: 1 0 auto;
  width: ${({ isWidthS }) => (isWidthS ? '100%' : '')};
`;

const MailInCtaLink = styled.a``;

const MailInCta = ({
  setInMailInStorageModalOpen,
  account,
  alignment,
  isWidthS,
}) => {
  const { t } = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState(true);
  // const learnMoreLink = useSelector(selectMailInLearnMoreLink);
  const sellMailInStorageUrl = useSelector(selectSellMailInStorageUrl);
  const dispatch = useDispatch();
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (!tooltipOpen) {
      setTooltipOpen(true);
      const currentRef = tooltipRef.current;
      if (tooltipRef?.current) {
        ReactTooltip.hide(currentRef);
      }
    }
  }, [tooltipOpen]);

  const onClick = () => {
    setInMailInStorageModalOpen(true);
    dispatch(
      postCrmEventMailinStorageStarted({
        accountUid: account.AccountUid,
      }),
    );
  };

  const TooltipContent = () => (
    <TooltipContainerRow>
      <Info width="20px" height="20px" />
      <TooltipContainerColumn>
        <TooltipContainerRow>
          <Anchor
            type="website"
            value={sellMailInStorageUrl}
            text={t('portfolio.mailIn.link')}
          />
          {t('portfolio.mailIn.postLinkText1')}
        </TooltipContainerRow>
        {t('portfolio.mailIn.postLinkText2')}
      </TooltipContainerColumn>
      <Close
        width="12px"
        height="12px"
        onClick={() => {
          if (tooltipRef?.current) {
            setTooltipOpen(false);
          }
        }}
      />
    </TooltipContainerRow>
  );

  return (
    <MailInCtaContainer alignment={alignment}>
      <MailInTitleWrapper>
        <Paragraph>{t('portfolio.mailIn.label')}</Paragraph>
        <IconWrapper ml={4} height={20} width={20} tooltip>
          <MailInCtaLink data-tip data-for="mailInStorageInfo">
            {tooltipOpen && (
              <ReactTooltip
                id="mailInStorageInfo"
                className="mailInStorageInfo"
                place="right"
                effect="solid"
                clickable
                delayHide={500}
                ref={tooltipRef}
                textColor={themeColors.colorBlack}
                backgroundColor={themeColors.colorBackgroundSecondary}
                borderColor={themeColors.colorBorderPrimary}
                arrowColor={themeColors.colorBackgroundSecondary}
              >
                <TooltipContent />
              </ReactTooltip>
            )}
            <Info width="20px" height="20px" />
          </MailInCtaLink>
        </IconWrapper>
      </MailInTitleWrapper>
      <MailInCtaButton isWidthS={isWidthS}>
        <Button
          variant="primary"
          textTransform="none"
          onClick={onClick}
          isWidthS={isWidthS}
        >
          {t('portfolio.mailIn.cta')}
        </Button>
      </MailInCtaButton>
      {/* {(learnMoreLink || sellMailInStorageUrl) && (
        <MailInCtaLink
          bold
          marginBottom={32}
          type="website"
          value={urlType === 'sell' ? sellMailInStorageUrl : learnMoreLink}
          text={t('portfolio.mailIn.link')}
        />
      )} */}
    </MailInCtaContainer>
  );
};

MailInCta.propTypes = {
  setInMailInStorageModalOpen: PropTypes.func,
  account: PropTypes.shape({
    AccountUid: PropTypes.string,
  }),
  alignment: PropTypes.bool,
  isWidthS: PropTypes.bool,
};

export default MailInCta;
